import FaqPage from './FaqPage';

export default FaqPage;



// WEBPACK FOOTER //
// ./src/app/FaqPage/index.js